module.exports = __webpack_public_path__ + "static/media/Phone Rounded.2f09f3a2.svg";